import React from 'react';
import PropTypes from 'prop-types';
import Select2 from "shared/react_components/Select2/index";
import FieldError from "./FieldError";

export default class AffiliateSelect extends React.Component {
  render() {
    const validationClass = this.props.errorMessage ? "sb-field-group--invalid" : "";

    return (
      <div className={`sb-field-group ${validationClass}`} data-affiliate-campaign-selector-row="true" data-mount="affiliate_campaign_id">
        <label className="sb-field-label">{this.props.nameLabel}</label>
        <div data-selector="affiliate-campaign-select">
          <Select2 {...this.selectArgs()} />
        </div>
        <FieldError errorMessage={this.props.errorMessage} />
      </div>
    );
  }

  selectArgs() {
    return {
      friendlyNameField: this.props.friendlyNameField,
      uniqueNameField:   this.props.uniqueNameField,
      url:               this.props.destinationCampaign.affiliateCampaignUrl,
      node:              this.props.destinationCampaign,
      allowSearch:       this.props.allowSearch,
      values:            this.props.values,
      changeListener:    this.props.changeListener,
      width:             "400px"
    };
  }
}

AffiliateSelect.propTypes = {
  nameLabel:            PropTypes.string.isRequired,
  urlParams:            PropTypes.object,
  urlBase:              PropTypes.string,
  friendlyNameField:    PropTypes.string,
  uniqueNameField:      PropTypes.string,
  allowSearch:          PropTypes.bool,
  values:               PropTypes.array,
  destinationCampaign:  PropTypes.object,
  changeListener:       PropTypes.func,
  errorMessage:         PropTypes.string
};

AffiliateSelect.defaultProps = {
  friendlyNameField:  "text",
  uniqueNameField:    "0",
  allowSearch:        true,
  values:             [],
  errorMessage:       ""
};
